import React, { useState, useEffect } from 'react';
import s from './OverviewTable.module.scss';

export default function OverviewTable({ allMerchantsStatistics, prevMerchantsStatistics }) {
    const [data, setData] = useState([]);
    const [currSortType, setCurrSortType] = useState('');
    const tableHeaders = [
        {
            title: 'Merhcant ID',
            property: '_id'
        },
        {
            title: 'Sessions',
            property: 'sessions'
        },
        {
            title: 'Previous Sessions',
            property: 'prevSessions'
        },
        {
            title: 'Posts',
            property: 'posts'
        },
        {
            title: 'Previous Posts',
            property: 'prevPosts'
        },
        {
            title: 'New Users',
            property: 'newUsers'
        },
        {
            title: 'Previous New Users',
            property: 'prevNewUsers'
        },
        {
            title: 'Guest',
            property: 'newGuestUsers'
        },
        {
            title: 'Signed',
            property: 'newSignedUsers'
        },
        {
            title: 'Interactions',
            property: 'interactions'
        },
        {
            title: 'Previous Interactions',
            property: 'prevInteractions'
        },
        {
            title: 'Wishlist',
            property: 'wishlist'
        },
        {
            title: 'Likes',
            property: 'likes'
        },
        {
            title: 'Comments',
            property: 'comments'
        },
        {
            title: 'Votes',
            property: 'votes'
        },
    ]
    useEffect(() => {
        if (allMerchantsStatistics && allMerchantsStatistics.length && prevMerchantsStatistics && prevMerchantsStatistics.length) {
            const newData = []
            allMerchantsStatistics.forEach((currStat) => {
                const foundPrevStat = prevMerchantsStatistics.find(prevStat => prevStat._id === currStat._id)
                if (foundPrevStat) {
                    currStat = {
                        ...currStat,
                        ...foundPrevStat
                    }
                    newData.push(currStat)
                }
            })
            setData(newData)
        }
    }, [allMerchantsStatistics, prevMerchantsStatistics]);

    const mainSortFunction = (e) => {
        const sortProperty = e.target.dataset.value
        if (currSortType !== sortProperty) {
            data.sort((a, b) => (a[sortProperty] < b[sortProperty]) ? 1 : ((b[sortProperty] < a[sortProperty]) ? -1 : 0));
            setCurrSortType(sortProperty)
        } else {
            setCurrSortType('')
            data.sort((a, b) => (a[sortProperty] > b[sortProperty]) ? 1 : ((b[sortProperty] > a[sortProperty]) ? -1 : 0));
        }
        setData(data)
    }

    return (
        <div className="card">
            <div className="card-body">
                <table className="table table-striped table-row-bordered gy-5 gs-7">
                    <thead>
                        <tr>
                            {tableHeaders.map(header => <th data-value={header.property} style={{ cursor: 'pointer' }} onClick={mainSortFunction} key={header.property}>
                                {header.title}
                            </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(stat =>
                            stat && stat._id ?
                                <tr className={s.tr} key={stat._id}>
                                    <td>{stat._id}</td>
                                    <td>{stat.sessions}</td>
                                    <td>{stat.prevSessions}</td>
                                    <td>{stat.posts}</td>
                                    <td>{stat.prevPosts}</td>
                                    <td>{stat.newUsers}</td>
                                    <td>{stat.prevNewUsers}</td>
                                    <td>{stat.newGuestUsers}</td>
                                    <td>{stat.newSignedUsers}</td>
                                    <td>{stat.interactions}</td>
                                    <td>{stat.prevInteractions}</td>
                                    <td>{stat.wishlist}</td>
                                    <td>{stat.likes}</td>
                                    <td>{stat.comments}</td>
                                    <td>{stat.votes}</td>
                                </tr>
                                : null
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    )
}
